import { AdEditorSideBarTabs } from 'views/ad-builder/AdBuilder';

// The sidebar tab that edits a canvas object of this type.
export const tabForObject = (type?: string) => {
  switch (type) {
    case 'text':
      return AdEditorSideBarTabs.TEXT_OPTIONS;
    case 'image':
      return AdEditorSideBarTabs.VISUAL_OPTIONS;
    default:
      return AdEditorSideBarTabs.SHAPE_OPTIONS;
  }
};
